import make, { Enum } from '@xaamin/enum';

class RetencionesMasivasTicketStatus extends Enum {

  name = 'RetencionesMasivasTicketStatus';

  enum = {
    pending: 0,
    cancelled :-1,
    error :-2,
    failed :-3,
    success: 1,
    queued: 2,
    duplicate: 3,
    undefined: 999
  }

}

export default make(RetencionesMasivasTicketStatus);